export default "__VITE_ASSET__d36e5104__"